import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';
import { Link as RouterLink } from 'react-router-dom';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  cursor: default;

  ${Media.xlg`
    flex-direction: column;
  `}
`;

export const EventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${props => props.theme.margin.default};

  ${Media.xlg`
    margin: ${props => props.theme.margin.xlg};
  `}
`;

export const Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background-color: ${props => props.theme.backgroundColor};
  padding: ${props => props.theme.padding.default};

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: -30px;
    width: 30px;
    height: 100%;
    background-color: ${props => props.theme.backgroundColor};
  }

  ${Media.xlg`
    padding: ${props => props.theme.padding.xlg};

    &:after {
      display: none;
    }
  `}
`;

export const HeadTitle = styled.div`
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}
`;

export const Button = styled(RouterLink)`
  background-color: ${props => props.theme.backgroundColor.default};
  padding: ${props => props.theme.padding.default};
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
  text-align: center;

  &:hover {
    background-color: ${props => props.theme.backgroundColor.hover};
  }

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
    padding: ${props => props.theme.padding.md};
  `}
`;

export const Box = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${props => props.theme.gap.default};
  padding: ${props => props.theme.padding.default};

  ${Media.sm`
    grid-template-columns: 1fr;
    gap: ${props => props.theme.gap.sm};
  `}
`;

export const Event = styled(RouterLink)`
  position: relative;
  background-color: ${props => props.theme.backgroundColor};
  padding: ${props => props.theme.padding.default};
  width: 100%;
  text-decoration: none;

  &:after {
    position: absolute;
    content: '${props => props.theme.after.content}';
    bottom: 9px;
    right: -8px;
    transform: rotate(270deg);
    transform-origin: top;
    transition: 0.2s all;
    background-color: ${props => props.theme.after.backgroundColor};
    color: ${props => props.theme.after.color};
    font-family: ${props => props.theme.after.fontFamily};
    font-size: ${props => `${props.theme.after.fontSize}rem`};
    line-height: ${props => props.theme.after.lineHeight};
    font-weight: ${props => props.theme.after.fontWeight};
    padding: ${props => props.theme.after.padding};
  }

  &:hover:after {
    background-color: ${props => props.theme.after.backgroundColorOnHover};
  }
`;

export const ImageBox = styled.div`
  position: relative;
  max-width: 100%;
  margin: ${props => props.theme.margin.default};
`;

export const Image = styled.img`
  display: block;
  margin: 0 auto;
  width: 100%;
`;

export const DateBox = styled.div`
  position: absolute;
  left: 10px;
  bottom: 0;
  transform: translateY(50%);
  min-width: 60px;
  background-color: ${props => props.theme.backgroundColor};
  padding: ${props => props.theme.padding.default};
  text-align: center;
`;

export const Day = styled.div`
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
  line-height: ${props => props.theme.lineHeight};
  margin: ${props => props.theme.margin.default};
`;

export const Month = styled.div`
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
  line-height: ${props => props.theme.lineHeight};
`;

export const EventTitle = styled.div`
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Text = styled.div`
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
  padding: ${props => props.theme.padding.default};

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const CalendarContainer = styled.div`
  position: relative;
  z-index: 1;
`;
